<template>
  <v-card>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('asset_wise.broker_id') }}</div>
          <input v-model.trim="localValue.brokerId" type="text" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('asset_wise.broker_name') }}</div>
          <input v-model.trim="localValue.brokerName" type="text" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('Start date') }}</div>
          <datepicker v-model="localValue.startDate" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('End date') }}</div>
          <datepicker v-model="localValue.endDate" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('email') }}</div>
          <input v-model.trim="localValue.email" type="email" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('Phone') }}</div>
          <input v-model.trim="localValue.phone" type="tel" class="ma-0" />
        </v-flex>
        <v-flex xs12 md4 xl3 class="form-control pa-2">
          <div>{{ $t('asset_wise.team') }}</div>
          <TeamOptionListProvider>
            <template #default="{ options, loading }">
              <multiselect
                v-model="localValue.team"
                :options="options"
                track-by="value"
                label="text"
                :show-labels="false"
                :allow-empty="false"
                :loading="loading"
              />
            </template>
          </TeamOptionListProvider>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="clear()">
        {{ $t('Clear Search') }}
      </v-btn>
      <v-btn color="primary" @click="emit()">
        <v-icon>search</v-icon>
        {{ $t('Search') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import TeamOptionListProvider from '../../providers/TeamOptionListProvider.vue'

export default {
  components: { Datepicker, Multiselect, TeamOptionListProvider },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localValue: {
        brokerId: '',
        brokerName: '',
        startDate: null,
        endDate: null,
        email: '',
        phone: '',
        team: { value: '', text: this.$t('All') },
        ...this.value
      }
    }
  },
  watch: {
    value(value) {
      this.localValue = { ...this.localValue, ...value }
    }
  },
  methods: {
    emit() {
      this.$emit('input', this.localValue)
    },
    clear() {
      this.localValue = {
        brokerId: '',
        brokerName: '',
        startDate: null,
        endDate: null,
        email: '',
        phone: '',
        team: { value: '', text: this.$t('All') }
      }
      this.emit()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/Broker/AdvancedSearch.vue